module.exports = __webpack_public_path__ + "static/img/storm.903df6b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/storm.jpeg
// module id = NhtD
// module chunks = 0